// extracted by mini-css-extract-plugin
export default {"commonRoundedButtonLink":"_6Ta8w","commonRoundedButton":"I1JFv","buttonSecondaryAlt":"QuvWi I1JFv"};